import React from 'react';
import { mockEvents } from '../../data/mockEvents';
import PlayerStatsTable from '../players/PlayerStatsTable';
import { useAuthContext } from '../../context/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import TeamBadgeUploader from '../TeamBadgeUploader';
import { usePageTitle } from '../../hooks/usePageTitle';

const Dashboard: React.FC = () => {
  usePageTitle('Dashboard | From the Pitchside');
  const { signOut } = useAuthContext();
  const matches = mockEvents.filter(e => e.type === 'Match' && !e.cancelled);
  const played = matches.length;
  const won = matches.filter(
    e => (e.homeScore ?? -1) > (e.awayScore ?? -1)
  ).length;
  const drawn = matches.filter(e => e.homeScore === e.awayScore).length;
  const lost = played - won - drawn;

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  const { user } = useAuthContext();

  const upcoming = mockEvents
    .filter(e => !e.cancelled && new Date(e.date + 'T' + e.time) > new Date())
    .sort(
      (a, b) =>
        new Date(a.date + 'T' + a.time).getTime() -
        new Date(b.date + 'T' + b.time).getTime()
    )
    .slice(0, 2);

  return (
    <div className="text-darkblue">
      <div>
        <h2 className='text-xl'>
          {getGreeting()} {user?.firstName}
        </h2>
      </div>

      {upcoming.length > 0 && (
        <div style={{ marginTop: '2rem' }}>
          <h3>Upcoming Events</h3>
          <ul>
            {upcoming.map(ev => (
              <li key={ev.id}>
                <strong>{ev.type}</strong> — {ev.date} at {ev.time}
                {ev.opponent ? ` vs ${ev.opponent}` : ''} — {ev.location}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
